import type { InstallTestV2V5ResultId } from "~domain/install-tests/models/v2v5/install-test-v2v5-model.ts";

import { z } from "zod";

export const backofficeFindV2v5InstallTestsResultsResponseSchema = z
  .object({
    id: z.number().transform((s) => s as InstallTestV2V5ResultId),
    measuredPower: z.number().nullable(),
    testResult: z.string(),
    testTarget: z.string(),
  })
  .array();

export type BackofficeFindV2v5InstallTestsResultsResponse = z.infer<
  typeof backofficeFindV2v5InstallTestsResultsResponseSchema
>;
